/*
 * Widerrufsbutton § 356a BGB — Client-Logik (Vanilla, kein Framework).
 * - Zweistufige UX (Button -> Formular)
 * - Client-Validierung (nur UX; die verbindliche Prüfung passiert serverseitig)
 * - Kurzlebiger Formular-Token und form-urlencoded POST über den Shopify App Proxy
 * - Double-Submit-Schutz, aria-live Statusmeldungen
 */
(function () {
  'use strict';

  function init(root) {
    var endpointUrl = root.getAttribute('data-endpoint-url');
    var tokenUrl = root.getAttribute('data-token-url');
    var stage1 = root.querySelector('[data-widerruf-stage="1"]');
    var form = root.querySelector('[data-widerruf-stage="2"]');
    var startBtn = root.querySelector('[data-widerruf-start]');
    var submitBtn = root.querySelector('[data-widerruf-submit]');
    var statusEl = root.querySelector('[data-widerruf-status]');
    if (!form || !startBtn || !submitBtn || !statusEl) return;

    var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    var submitted = false;

    function setStatus(message, tone) {
      statusEl.textContent = message || '';
      if (tone) {
        statusEl.setAttribute('data-tone', tone);
      } else {
        statusEl.removeAttribute('data-tone');
      }
    }

    // Stufe 1 -> Stufe 2
    startBtn.addEventListener('click', function () {
      if (stage1) stage1.hidden = true;
      form.hidden = false;
      var first = form.querySelector('input, textarea');
      if (first) first.focus();
    });

    function clientValidate(data) {
      if (!data.name || data.name.length > 120) return 'Bitte geben Sie Ihren Namen an (max. 120 Zeichen).';
      if (!data.email || data.email.length > 200 || !EMAIL_RE.test(data.email)) return 'Bitte geben Sie eine gültige E-Mail-Adresse an.';
      if (!data.orderNumber || data.orderNumber.length > 40) return 'Bitte geben Sie Ihre Bestellnummer an (max. 40 Zeichen).';
      if (data.note && data.note.length > 1000) return 'Der optionale Hinweis ist zu lang (max. 1000 Zeichen).';
      return null;
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (submitted) return;

      var data = {
        name: (form.elements.name && form.elements.name.value || '').trim(),
        email: (form.elements.email && form.elements.email.value || '').trim(),
        orderNumber: (form.elements.orderNumber && form.elements.orderNumber.value || '').trim(),
        note: (form.elements.note && form.elements.note.value || '').trim(),
        company: (form.elements.company && form.elements.company.value || '') // Honeypot
      };

      var clientError = clientValidate(data);
      if (clientError) {
        setStatus(clientError, 'error');
        return;
      }

      submitBtn.disabled = true;
      setStatus('Ihr Widerruf wird übermittelt …', null);

      fetch(tokenUrl, {
        method: 'GET',
        credentials: 'omit'
      })
        .then(function (response) {
          return response.json().catch(function () { return {}; }).then(function (body) {
            if (!response.ok || !body.form_token) throw new Error('token');
            return body.form_token;
          });
        })
        .then(function (formToken) {
          var params = new URLSearchParams();
          params.append('name', data.name);
          params.append('email', data.email);
          params.append('orderNumber', data.orderNumber);
          params.append('note', data.note);
          params.append('company', data.company);
          params.append('form_token', formToken);

          return fetch(endpointUrl, {
            method: 'POST',
            credentials: 'omit',
            body: params
          });
        })
        .then(function (response) {
          return response.json().catch(function () { return {}; }).then(function (body) {
            return { ok: response.ok, status: response.status, body: body };
          });
        })
        .then(function (res) {
          if (res.ok && res.body && res.body.status === 'ok') {
            submitted = true;
            // Felder sperren, Erfolg mit Server-Timestamp anzeigen
            Array.prototype.forEach.call(form.elements, function (el) { el.disabled = true; });
            var when = res.body.received_at_local ? ' (Eingang: ' + res.body.received_at_local + ' Uhr)' : '';
            setStatus('Vielen Dank. Ihr Widerruf ist bei uns eingegangen' + when + '. Sie erhalten in Kürze eine Bestätigung per E-Mail.', 'success');
          } else {
            var msg = (res.body && res.body.message) ? res.body.message : 'Die Übermittlung ist fehlgeschlagen. Bitte versuchen Sie es erneut.';
            setStatus(msg, 'error');
            submitBtn.disabled = false;
          }
        })
        .catch(function () {
          setStatus('Netzwerkfehler — bitte prüfen Sie Ihre Verbindung und versuchen Sie es erneut.', 'error');
          submitBtn.disabled = false;
        });
    });
  }

  function boot() {
    var roots = document.querySelectorAll('[data-widerruf-form]');
    Array.prototype.forEach.call(roots, init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
